import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../css/TermsConditions.css";
import { branding } from "../utils/branding";

const TermsAndConditions = () => {
  const currentYear = new Date().getFullYear();
  const formattedDate = new Date().toLocaleDateString();

  return (
    <div className="terms-page">
      {/* Back Button */}
      <div className="mb-4">
        <Link to={-1} className="btn terms-back-btn">
          <FaArrowLeft className="me-2" />
          Go Back
        </Link>
      </div>

      {/* Title */}
      <h1 className="text-center fw-bold terms-title mb-3">
        Terms &amp; Conditions
      </h1>
      <p className="text-center textsec mb-5">
        Last updated: {formattedDate}
      </p>

      {/* Content */}
      <div className="terms-card">
        <section className="mb-4">
          <h4 className="terms-title">1. Introduction</h4>
          <p>
            Welcome to <strong>{branding("ZeroBox")}</strong>. These Terms &amp; Conditions govern your access to
            and use of our chatbot service, including any associated
            websites through which the Service is offered.
            By registering an account, accessing or using the Service you agree to be
            bound by these Terms. If you do not agree with all of the Terms, you must
            immediately cease all use of the Service.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="terms-title">2. Eligibility &amp; Account Responsibility</h4>
          <p>
            You represent and warrant that you are at least of the legal age required
            in your jurisdiction (typically 13 or older), or have obtained parent/guardian
            consent where required. You are responsible for maintaining the confidentiality
            of your account credentials and for all activities that occur under your account.
            You must notify us immediately if you suspect any unauthorized access.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="terms-title">3. Use of the Service</h4>
          <p>
            <strong>Permitted Use:</strong> You may use the Service solely for your personal,
            non-commercial purposes in accordance with these Terms and all applicable laws.
          </p>
          <p>
            <strong>Prohibited Use:</strong> You must not use the Service for illegal, harmful,
            fraudulent or abusive activities including but not limited to: harassment,
            threats, defamation, hate speech; spamming, phishing, distributing malware;
            infringing intellectual property or privacy rights of others; or generating
            unlawful or harmful content. You acknowledge the Service may produce AI-generated
            content and agree to use your own judgment when interpreting or relying on any output.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="terms-title">4. Privacy, Data &amp; Intellectual Property</h4>
          <p>
            <strong>Privacy:</strong> We value your privacy. Please review our{' '}
            <Link to="/privacy" className="terms-link">
              Privacy Policy
            </Link>{' '}
            for full details. By using the Service you consent to the collection, use
            and retention of data as described therein.
          </p>
          <p>
            <strong>Data Use:</strong> We may collect usage data, analytics, log information
            and other technical data (“Usage Data”) to maintain, improve and evolve the Service.
            We will not sell your personal data to third parties.
          </p>
          <p>
            <strong>Intellectual Property:</strong> Unless otherwise indicated, the Service
            and all content, software, functions, materials and trademarks associated with it
            are the property of AI Privacy ChatBot or its licensors. You may not reproduce,
            copy, modify, distribute, republish or exploit any part of the Service without our
            prior written permission.
          </p>
        </section>

        {/* <section className="mb-4">
          <h4 className="terms-title">5. Disclaimers &amp; Limitations of Liability</h4>
          <p>
            The Service is provided “as-is” and “as-available”, without warranties of any kind,
            either express or implied. We do not guarantee the Service will be uninterrupted,
            error-free or secure.
          </p>
          <p>
            To the maximum extent permitted by law, in no event shall AI Privacy ChatBot,
            its affiliates or licensors be liable for any indirect, incidental, special,
            consequential or punitive damages arising out of or related to your use of
            the Service, even if advised of the possibility of such damages. You agree
            that your use of the Service and any reliance on its output is at your own risk.
            The Service is not a substitute for professional advice (legal, medical,
            financial or other).
          </p>
        </section> */}

        {/* <section className="mb-4">
          <h4 className="terms-title">6. Modifications, Suspension &amp; Termination</h4>
          <p>
            We reserve the right to modify, suspend or discontinue the Service (or any
            part thereof) at any time by giving reasonable notice (except where immediate
            suspension is required, for example due to illegal activity). We may also
            revise these Terms at our discretion. The “Last updated” date at the top will reflect changes.
            Continued use of the Service after changes constitutes your acceptance of the revised Terms.
          </p>
          <p>
            Upon termination or suspension, your right to use the Service will immediately
            cease and we may delete or deactivate your account and content.
          </p>
        </section> */}

        <section className="mb-4">
          <h4 className="terms-title">5. Governing Law &amp; Dispute Resolution</h4>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the
            jurisdiction in which the Service provider is established, without regard to
            its conflict of law principles. You and the provider agree to submit to the
            exclusive or non-exclusive jurisdiction of the courts in that jurisdiction or agree
            to arbitration if applicable.
          </p>
        </section>

        <section>
          <h4 className="terms-title">6. Contact Information</h4>
          <p>
            If you have any questions or concerns about these Terms, please contact us at{' '}
            <a
              href="mailto:support@aiprivacychatbot.com"
              className="terms-link"
            >
              support@nextastra.com
            </a>
            .
          </p>
        </section>
      </div>

      <footer className="text-center textsec mt-5">
        © {currentYear} AI Privacy ChatBot. All rights reserved.
      </footer>
    </div>
  );
};

export default TermsAndConditions;
